// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__br4wz","signatureButtonsRight":"ModalSign_signatureButtonsRight__1yaNb"};